import NewSectionTitle from '@components/shared/NewSectionTitle';
import cn from 'classnames';
import { PrimaryDotWithOutline } from 'stories/Dot.stories';

const howItWorksPoint = [
  {
    title: 'Connect with our placement team',
    description: 'Book a demo session to understand our hiring proposition. It only takes 15 min!',
  },
  {
    title: 'Share your requirements',
    description: 'Receive triple-filtered candidates basis your JD within 3 hrs',
  },
  {
    title: 'Conduct interviews',
    description:
      'Availability of the shortlisted students shall be ensured by the placement team to expedite the hiring process.',
  },
  {
    title: 'Roll out offers',
    description:
      'Recruiters can roll out offers to outstanding performers. Our team helps in quick joining of the candidates.',
  },
];

const HowItWorks = () => {
  return (
    <div className="flex flex-col items-center gap-y-[48px] bg-[#F9FAFB] px-[16px] py-[60px] md:py-[120px]">
      <NewSectionTitle text={'How it'} highlightedText={'Works?'} />

      <div className="flex flex-col">
        {howItWorksPoint.map((point, index) => {
          const pointer = index + 1;

          return (
            <TimelinePoints
              key={pointer}
              point={pointer}
              {...point}
              reversePoint={pointer % 2 === 0}
            />
          );
        })}
      </div>
    </div>
  );
};

export default HowItWorks;

function TimelinePoints({ reversePoint = false, point, title, description }) {
  return (
    <>
      <div
        className={cn('relative flex h-28 flex-row-reverse gap-[16px] px-[24px] md:flex-row', {
          'md:flex-row-reverse': reversePoint,
        })}
      >
        <div
          className={cn('flex flex-col items-start gap-y-[4px] md:w-3/5 md:pb-[16px]', {
            'md:items-end': !reversePoint,
          })}
        >
          <h3 className="font-satoshi-bold text-[20px] leading-7 text-red md:text-center">
            {title}
          </h3>
          <p className={cn('text-[16px] leading-6', { 'md:text-end': !reversePoint })}>
            {description}
          </p>
        </div>

        <div className={cn('relative mt-1 flex items-start justify-center')}>
          {/* <span className="h-1 w-1 rounded-full bg-gray-11"></span> */}
          {/* <span className="mt-1 flex h-6 w-6 items-center justify-center rounded-full bg-red text-[14px] leading-5 text-white md:mt-0">
            {point || 1}
          </span> */}
          <PrimaryDotWithOutline size={'xl'} />

          {point !== 4 && (
            <span className="absolute top-5 h-4/5 w-0.5 rounded-full bg-gray-3"></span>
          )}
        </div>

        <div
          className={cn('hidden justify-center md:flex md:w-3/5', {
            'md:items-start': !reversePoint,
            'md:items-end': reversePoint,
          })}
        ></div>
      </div>
    </>
  );
}
